import React from "react";
import { DetailsPlaceholder } from "./HubletViewStyles/HubletViewStyles";
import {
  useHubletViewProcess,
  useLastSegmentDetails,
  useHideOverflowHubletView,
  useStatusTimeHubletView,
  useIsCall,
  useCallTimeDisplay,
} from "./hubletViewUtils";

import { HubletViewContent } from "./HubletViewContent";
import { useSelectedDay } from "../../../utils/customHooks/genericHooks";
import { useIsStorybook } from "../../../utils/customHooks/storyHooks";
import ErrorBoundary from "../../SimpleComponents/Errors/ErrorBoundary";
import { getIsIe11 } from "constants/constants";
import { useLastDataDumpRow } from "components/DataGetter/LastDataDumpRowGetter";

type HubletViewProps = {
  isGridLayout?: boolean;
  hasResized?: boolean;
};

const HubletView = React.memo<HubletViewProps>(
  ({ isGridLayout = false, hasResized = false }) => {
    const isStorybook = useIsStorybook();
    const selectedDay = useSelectedDay();
    // hide middle item if not on today
    const isToday =
      isStorybook ||
      (selectedDay && selectedDay.range && selectedDay.range.lt >= Date.now());

    const process = useHubletViewProcess();

    const { segment, pnlCategory } = useLastSegmentDetails();

    useHideOverflowHubletView();

    const {
      showCountdown,
      isNegative,
      displayedTime1,
      displayedUnit1,
      displayedTime2,
      displayedUnit2,
      isLessThanOneMinute,
    } = useStatusTimeHubletView();

    const isCall = useIsCall();
    const { displayedCallTime, displayedCallUnit } =
      useCallTimeDisplay(showCountdown);

    const [lastDataDumpRow] = useLastDataDumpRow();

    if (!process?.name) {
      // wait until ready
      return <DetailsPlaceholder />;
    }

    const isIE = getIsIe11();

    return (
      <ErrorBoundary id={"HubletView"}>
        <HubletViewContent
          {...{
            isCall,
            isLessThanOneMinute,
            displayedTime1,
            displayedUnit1,
            displayedTime2,
            displayedUnit2,
            isToday,
            isNegative,
            displayedCallTime,
            displayedCallUnit,
            isIE,
            skuCodeDisplay: lastDataDumpRow?.skuCode || "",
            skuDisplay: lastDataDumpRow?.skuName || "",
            status: segment?.tag?.name || "",
            callTarget: lastDataDumpRow?.callTarget ?? "",
            ge: segment?.range.ge ? segment.range.ge : null,
            processName: process?.name,
            pnlCategory,
            teamSize: lastDataDumpRow?.teamSize,
            isCallAnimationActive: !isStorybook,
            isGridLayout,
            showCountdown,
            processId: process?.id,
            hasResized,
          }}
        />
      </ErrorBoundary>
    );
  }
);

export default HubletView;
